import axios from 'axios';
import { useAuth } from '@clerk/clerk-react';
import { useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
});

let _getToken = null;

export function useClerkTokenInterceptor() {
  const { getToken } = useAuth();

  useEffect(() => {
    _getToken = getToken;
  }, [getToken]);
}

api.interceptors.request.use(async (config) => {
  if (_getToken) {
    const token = await _getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Client für den anonymen Audit-Flow (AUD-53): kein Clerk-Bearer-Token, dafür
// withCredentials, damit der signierte httpOnly-Cookie mitgesendet/gesetzt wird.
export const publicApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export default api;
